"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpeningHours = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const openingHours_1 = require("@geome/react-components-next/lib/components/openingHours");
const clock_1 = require("./icons/clock");
const react_next_1 = require("@geome/react-next");
const OpeningHours = ({ location }) => {
    const { translate } = (0, react_next_1.useI18n)();
    const { forecourt_opening_hours: forecourtOpeningHours, shop_opening_hours: shopOpeningHours, carwash_opening_hours: carwashOpeningHours, } = location;
    const { isMobile } = (0, react_1.useContext)(react_next_1.EnvironmentContext);
    const tables = (0, react_1.useMemo)(() => {
        const times = [
            {
                title: translate("station_page.sections.opening_hours.forecourt"),
                daysAndTimes: forecourtOpeningHours,
            },
            {
                title: translate("station_page.sections.opening_hours.shop"),
                daysAndTimes: shopOpeningHours,
            },
            {
                title: translate("station_page.sections.opening_hours.carwash"),
                daysAndTimes: carwashOpeningHours,
            },
        ].filter(({ daysAndTimes }) => Array.isArray(daysAndTimes) && daysAndTimes.length > 0);
        return times;
    }, [forecourtOpeningHours, shopOpeningHours, carwashOpeningHours]);
    return ((0, jsx_runtime_1.jsx)(openingHours_1.OpeningHours, { sectionName: "opening_hours", configPath: "station_page.", tables: tables, renderIcon: () => (0, jsx_runtime_1.jsx)(clock_1.ClockIcon, {}), singleTable: !isMobile }));
};
exports.OpeningHours = OpeningHours;
